import { call, put, takeEvery } from "redux-saga/effects";

import { ILoadLocalizationItemsAction, LOAD_LOCALIZATION_ITEMS } from "@multiweb/reactCore/bridge/api";
import { SagaWithReturnType, SagaYieldReturn } from "@multiweb/types/react";
import { createLocalizationItemsLoadedAction } from "../actions";
import { StoryBridge } from "./StoryBridge";

/**
 * Vytvoří ságy zajišťující obsluhu obecné funkcionality bridge modulu pro použití ve Storybooku.
 * Ságy nejsou definované staticky, ale vytváří se touto funkcí, aby bylo možné specifikovat vlastní
 * implementaci bridge modulu, kterou ságy použijí.
 *
 * Tento přístup zvyšuje znovupoužitelnost ság, ale na úkor testovatelnosti. Pro účely storybooku se však obejdeme bez unit testů.
 *
 * @param storyBridge Implementace bridge modulu, kterou ságy použijí.
 */
export const createStoryBridgeSaga = (storyBridge: StoryBridge): SagaWithReturnType => {
    const { loadLocalizationItems } = storyBridge;

    const saga: SagaWithReturnType = function* storyBridgeSaga() {
        yield takeEvery(LOAD_LOCALIZATION_ITEMS, loadLocalizationItemsSaga);
    };

    const loadLocalizationItemsSaga: SagaWithReturnType<[ILoadLocalizationItemsAction]> = function* loadLocalizationItemsSaga(action) {
        const { locKeys, key } = action.payload;
        const localizationData: SagaYieldReturn<typeof loadLocalizationItems> = yield call(loadLocalizationItems, locKeys);
        yield put(createLocalizationItemsLoadedAction(localizationData, key));
    };

    return saga;
};
